import React from 'react';
import { BoxDimensions } from '../types';

type DimensionControlsProps = {
  dimensions: BoxDimensions;
  onChange: (nextDimensions: BoxDimensions) => void;
};

const DIMENSION_FIELDS: Array<keyof BoxDimensions> = [
  'length',
  'width',
  'height',
];

const LABELS: Record<keyof BoxDimensions, string> = {
  length: 'Length',
  width: 'Width',
  height: 'Height',
};

const MINIMUM_DIMENSION = 20;
const MAXIMUM_DIMENSION = 1200;

const DimensionControls: React.FC<DimensionControlsProps> = ({
  dimensions,
  onChange,
}) => {
  const updateDimension = (field: keyof BoxDimensions, rawValue: string) => {
    const parsedValue = Number(rawValue);

    if (!Number.isFinite(parsedValue)) return;

    onChange({
      ...dimensions,
      [field]: Math.min(
        MAXIMUM_DIMENSION,
        Math.max(MINIMUM_DIMENSION, parsedValue)
      ),
    });
  };

  return (
    <section className="die-line__controls">
      <div className="die-line__heading">
        <p className="die-line__eyebrow">Box type</p>
        <h1>Butterfly box</h1>
        <p>
          Change the finished internal dimensions. The dieline updates
          automatically.
        </p>
      </div>

      <div className="die-line__dimension-grid">
        {DIMENSION_FIELDS.map((field) => (
          <label className="die-line__field" key={field}>
            <span>{LABELS[field]}</span>
            <div className="die-line__input-shell">
              <input
                type="number"
                min={MINIMUM_DIMENSION}
                max={MAXIMUM_DIMENSION}
                step="1"
                value={dimensions[field]}
                onChange={(event) => updateDimension(field, event.target.value)}
              />
              <span>mm</span>
            </div>
          </label>
        ))}
      </div>

      <div className="die-line__fixed-settings">
        <h2>Fixed for this version</h2>
        <dl>
          <div>
            <dt>Style</dt>
            <dd>Butterfly mailer</dd>
          </div>
          <div>
            <dt>Dimension mode</dt>
            <dd>Internal</dd>
          </div>
          <div>
            <dt>Material</dt>
            <dd>Paperboard / micro flute</dd>
          </div>
        </dl>
      </div>
    </section>
  );
};

export default DimensionControls;
